import { fromPromise, assign, setup } from "xstate-5";
import axios from "axios";
import { DTOBillingEngagementRates } from "vue-app/api/dto";
import { InjectionKey } from "vue";
import { useMachine } from "@xstate-5/vue";

type Context = {
  data?: DTOBillingEngagementRates;
};

type Events = { type: "FETCH" } | { type: "RETRY" } | { type: "RESET" };

export const machine = setup({
  types: {
    context: {} as Context,
    events: {} as Events,
  },

  actors: {
    load: fromPromise(async () => {
      const { data } = await axios.get<DTOBillingEngagementRates>("/billing/engagement-rates");
      return data;
    }),
  },
}).createMachine({
  id: "EngagementRateStatus",
  context: {
    data: undefined,
  },
  initial: "loading",
  states: {
    loading: {
      tags: "loading",
      invoke: {
        id: "loadData",
        src: "load",
        onDone: {
          target: "success",
          actions: assign({
            data: ({ event }) => event.output,
          }),
        },
        onError: {
          target: "error",
          actions: assign({
            data: () => undefined,
          }),
        },
      },
    },
    success: {
      tags: "success",
      on: {
        FETCH: "loading",
      },
    },
    error: {
      tags: "error",
      on: {
        RETRY: "loading",
      },
    },
  },
});

export const symbol: InjectionKey<ReturnType<typeof useMachine<typeof machine>>> = Symbol();
